<div class="xvi-icons-renderer">
  <button
    appThrottleClick
    class="x_btn x_sm x_primary"
    (throttledClick)="clickHandler(params)"
  >
    {{ buttonText | translate }}
  </button>
</div>
